/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify'
import { FaTimesCircle } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'

import { useStateContext } from '../../../state/context'
import { updateHospitalConfig } from '../../../state/actions/admin.actions'


const UpdateHospitalInfoModal = () => {
    const dispatch = useDispatch()

    const { modals, setModals } = useStateContext()

    const { hospital_config } = useSelector(state => state.admin)

    const [formData, setFormData] = useState({ id: '', name: '', phone: '', sms_tag: '', email: '', address: '' })

    useEffect(() => {
        setFormData({
            ...formData,
            id: hospital_config?.id,
            name: hospital_config?.name,
            phone: hospital_config?.phone,
            sms_tag: hospital_config?.sms_tag,
            email: hospital_config?.email,
            address: hospital_config?.address
        })

    }, [hospital_config])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        console.log(formData)
        dispatch(updateHospitalConfig({ formData, toast, modals, setModals }))
    }

    return (
        <div className="fixed grid h-screen w-full z-10 bg-[#11111180] place-items-center">
            <div className="bg-white w-[614px] rounded px-[30px] py-[20px]">
                <div className="flex flex-col space-y-5">
                    <div className="flex justify-between items-center">
                        <h4 className={`text-sky-600 text-[16px] font-medium capitalize`}>
                            Update Hospital Data
                        </h4>
                        <FaTimesCircle
                            size={20}
                            className="text-dark-yellow cursor-pointer"
                            onClick={() => {
                                setModals({ ...modals, showAdminUpdateHospitalInfoModal: !modals.showAdminUpdateHospitalInfoModal })
                            }}
                        />
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div>
                            <input
                                type="text"
                                name="name"
                                className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                value={formData?.name}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>

                        <div>
                            <input
                                type="text"
                                name="phone"
                                className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                value={formData?.phone}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>

                        <div>
                            <input
                                type="text"
                                name="email"
                                className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                value={formData?.email}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>

                        <div>
                            <input
                                type="text"
                                name="sms_tag"
                                className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                value={formData?.sms_tag}
                                onChange={(e) => handleChange(e)}
                            />
                        </div>

                        {/* <div className='flex justify-center space-x-5 items-center w-full py-4'>
                            <img
                                src={`http://localhost:8000${hospital_config?.logo}`}
                                alt=""
                                className='w-[30px] h-[30px] rounded-full'
                            />
                            <div
                                onClick={() => logoRef.current.click()}
                                className="border p-2 rounded-md cursor-pointer"
                            >
                                <AiOutlineCloudUpload
                                    size={40}
                                />
                            </div>
                            <input
                                ref={logoRef}
                                type="file"
                                name="logo"
                                className="hidden"
                                accept='image/jpeg, image/png, image/jpg'
                                onChange={(e) => handleFileChange(e)}
                            />
                        </div> */}

                        <div>
                            <textarea
                                rows="4"
                                type="text"
                                name="address"
                                className="border rounded w-full px-4 py-2 resize-none mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                value={formData?.address}
                                onChange={(e) => handleChange(e)}
                            ></textarea>
                        </div>


                        <div className="mt-4">
                            <button
                                type="submit"
                                className="inline-block w-[175px] px-6 py-2.5 bg-sky-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                            >
                                Update
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default UpdateHospitalInfoModal
